document.addEventListener('DOMContentLoaded', () => {
  const eventAttributes = ['data-event-category', 'data-event-action', 'data-event-name'];

  const containsEventDataAttributes = (attributes) => {
    for (const attr of eventAttributes) {
      if (!attributes.includes(attr)) {
        return false;
      }
    }

    return true;
  };

  const getFriendlyPageNameFromURL = () => {
    const path = window.location.pathname;
    const parts = path.split('/').filter((v) => v);

    if (parts.length === 0) {
      return 'Homepage';
    }

    // Mean there are 1 or more parts so lets sanitize and join them
    return parts.map((p) => {
      const value = (p||'').replace(/[-_]/g, ' ');
      return value.charAt(0).toUpperCase() + value.slice(1);
    }).join(' ').trim() + ' page';
  }


  const onClickEmitEvent = (e) => {
    if (!window._paq) {
      return;
    }

    const category = e.currentTarget.getAttribute('data-event-category');
    const action = e.currentTarget.getAttribute('data-event-action');
    const name = e.currentTarget.getAttribute('data-event-name');

    if (category && action && name) {
      // Use the detailed event info from the element
      window._paq.push(['trackEvent', category, action, name]);
    } else {
      // Fallback to page and button click we already know its for signup
      window._paq.push(['trackEvent', 'Signup', 'Signup started', `${getFriendlyPageNameFromURL()} - ${(e.currentTarget.textContent|| '').trim()}`]);
    }
  };

  const links = document.querySelectorAll('a')

  for (const link of links) {
    if (containsEventDataAttributes(link.getAttributeNames()) || link.href.includes('try-geckoboard')) {
      link.addEventListener("click", onClickEmitEvent, false);
    }
  }
});
